document.addEventListener('DOMContentLoaded', function () {
    const freeGiftContainer = document.getElementById("free-gift-container");
    const freeGiftCheckboxes = document.querySelectorAll(".free-gift-checkbox");

    function updateGiftInputs() {
        freeGiftContainer.innerHTML = ""; 

        let index = 0;

        freeGiftCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const variantId = checkbox.getAttribute("data-variant-id");

                const itemInput = document.createElement("input");
                itemInput.type = "hidden";
                itemInput.name = `items[${index}][id]`;
                itemInput.value = variantId;
                freeGiftContainer.appendChild(itemInput);

                index++;
            }
        });
    }

    freeGiftCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", updateGiftInputs);
    });

    updateGiftInputs(); 
});


// document.addEventListener('DOMContentLoaded', () => {
//   // Use event delegation on document to handle dynamic elements
//   document.addEventListener('click', e => {
//     const removeButton = e.target.closest('.btn-minicart__remove-js, .cart-remove');
//     if (!removeButton) return; // Exit if not a remove button

//     e.preventDefault(); // Prevent default behavior
//     console.log('Remove button clicked:', removeButton, 'Class:', removeButton.className);

//     const cartItem = removeButton.closest('.cart-item');
//     if (!cartItem) {
//       console.error('Cart item not found for remove button');
//       return;
//     }

//     const productInfo = cartItem.querySelector('.minicart__product-info');
//     if (!productInfo) {
//       console.error('Product info not found in cart item');
//       return;
//     }

//     const productOptions = productInfo.querySelectorAll('.product-option');
//     console.log('Product options found:', productOptions.length);

//     const isMainProduct = Array.from(productOptions).some(option => {
//       const firstSpan = option.querySelector('span');
//       return firstSpan?.textContent.includes('bundle_main_product:');
//     });
//     console.log('Is main product:', isMainProduct);

//     if (isMainProduct) {
//       // Get the bundle_main_product value
//       let bundleMainValue = '';
//       productOptions.forEach(option => {
//         const spans = option.querySelectorAll('span');
//         if (spans[0]?.textContent.includes('bundle_main_product:')) {
//           bundleMainValue = spans[1]?.textContent.trim();
//         }
//       });
//       console.log('Bundle main value:', bundleMainValue);

//       if (!bundleMainValue) {
//         console.error('Bundle main value not found');
//         return;
//       }

//       // Find all cart items with matching bundle_data
//       const allCartItems = document.querySelectorAll('.minicart-form .cart-item');
//       console.log('Total cart items:', allCartItems.length);
//       const itemsToRemove = [];

//       allCartItems.forEach(currentCartItem => {
//         const currentProductInfo = currentCartItem.querySelector('.minicart__product-info');
//         if (!currentProductInfo) return;

//         const bundleDataValue = Array.from(currentProductInfo.querySelectorAll('.product-option')).reduce((value, option) => {
//           const spans = option.querySelectorAll('span');
//           if (spans[0]?.textContent.includes('bundle_data:')) {
//             return spans[1]?.textContent.trim() || value;
//           }
//           return value;
//         }, '');

//         console.log('Checking cart item:', currentCartItem.id, 'Bundle data:', bundleDataValue);

//         if (bundleDataValue === bundleMainValue) {
//           const removeLink = currentProductInfo.querySelector('.cart-remove');
//           if (removeLink) {
//             const fullId = removeLink.href.match(/id=([^&]+)/)?.[1];
//             if (fullId) itemsToRemove.push(fullId);
//           }
//         }
//       });
//       console.log('Items to remove:', itemsToRemove);

//       // Remove all matching items via AJAX with delay
//       removeItemsViaAjax(itemsToRemove);
//     } else {
//       // Remove single item via AJAX
//       const removeLink = productInfo.querySelector('.cart-remove');
//       const fullId = removeLink?.href.match(/id=([^&]+)/)?.[1];
//       if (fullId) {
//         console.log('Removing single item:', fullId);
//         removeItemsViaAjax([fullId]);
//       } else {
//         console.error('Item ID not found for single item removal');
//       }
//     }
//   });

//   // Delay function to pause execution
//   function delay(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
//   }

//   // Function to remove items via Shopify AJAX API with 0.5s delay
//   async function removeItemsViaAjax(itemIds) {
//     if (itemIds.length === 0) {
//       console.warn('No items to remove');
//       return;
//     }

//     // Fetch current cart to validate item IDs
//     try {
//       const response = await fetch('/cart.js', {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/json'
//         }
//       });
//       console.log('Cart fetch status:', response.status);
//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//       const cart = await response.json();
//       console.log('Current cart:', cart);

//       // Validate item IDs against cart
//       const validItemIds = itemIds.filter(id => 
//         cart.items.some(item => item.key === id)
//       );
//       console.log('Valid item IDs:', validItemIds);

//       if (validItemIds.length === 0) {
//         console.warn('No valid items to remove');
//         updateCartUI();
//         return;
//       }

//       // Remove items one by one with 0.5s delay
//       for (let i = 0; i < validItemIds.length; i++) {
//         const id = validItemIds[i];
//         console.log(`Removing item: ${id}`);

//         try {
//           const response = await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json'
//             },
//             body: JSON.stringify({
//               id: id,
//               quantity: 0
//             })
//           });
//           console.log('Response status:', response.status);
//           if (!response.ok) {
//             const text = await response.text();
//             throw new Error(`HTTP error! Status: ${response.status}, Response: ${text}`);
//           }
//           const data = await response.json();
//           console.log('Item removed:', data);

//           // Update UI immediately after each removal for visual effect
//           await updateCartUI();

//           // Wait 0.5s before next removal (skip for last item)
//           if (i < validItemIds.length - 1) {
//             console.log('Waiting 0.5s before next removal');
//             await delay(500);
//           }
//         } catch (error) {
//           console.error('Error removing item:', error);
//           // showError('Failed to remove item. Please try again.');
//           // Continue to next item to avoid stopping
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//       showError('Failed to validate cart. Please try again.');
//       // Fallback to clear cart
//       await fallbackClearCart();
//     }
//   }

//   // Fallback to clear entire cart
//   async function fallbackClearCart() {
//     console.log('Attempting to clear cart as fallback');
//     try {
//       const response = await fetch('/cart/clear.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         }
//       });
//       console.log('Clear cart status:', response.status);
//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//       const data = await response.json();
//       console.log('Cart cleared:', data);
//       await updateCartUI();
//     } catch (error) {
//       console.error('Error clearing cart:', error);
//       showError('Failed to clear cart. Please refresh the page.');
//     }
//   }

//   // Function to update minicart UI after removal
//   async function updateCartUI() {
//     console.log('Updating cart UI');
//     try {
//       const response = await fetch('/cart.js', {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/json'
//         }
//       });
//       console.log('Cart fetch status:', response.status);
//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//       const cart = await response.json();
//       console.log('Cart data:', cart);

//       const itemsContainer = document.querySelector('.minicart-form .items');
//       if (!itemsContainer) {
//         console.error('Items container not found');
//         return;
//       }

//       document.querySelectorAll('.minicart-form .cart-item').forEach(item => {
//         const itemId = item
//           .querySelector('.cart-remove')
//           ?.href.match(/id=([^&]+)/)?.[1];
//         const isInCart = cart.items.some(cartItem => cartItem.key === itemId);

//         if (!isInCart) {
//           console.log('Removing item from DOM:', itemId);
//           item.remove();
//         }
//       });

//       // Show empty cart message if no items remain
//       if (cart.items.length === 0) {
//         itemsContainer.innerHTML = '<p class="text-center">Your cart is empty.</p>';
//       }

//       // Update totals
//       const subtotal = (cart.total_price / 100).toFixed(2);
//       const subtotalElement = document.querySelector('.minicart-subtotal');
//       if (subtotalElement) {
//         subtotalElement.textContent = `$${subtotal}`;
//       } else {
//         console.warn('Subtotal element not found');
//       }

//       const cartCountElement = document.querySelector('.cart-count');
//       if (cartCountElement) {
//         cartCountElement.textContent = cart.item_count;
//       } else {
//         console.warn('Cart count element not found');
//       }
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//       showError('Failed to update cart. Please refresh the page.');
//     }
//   }

//   // Function to show user-facing error messages
//   function showError(message) {
//     const errorContainer = document.querySelector('.minicart-form .cart-error');
//     if (errorContainer) {
//       errorContainer.textContent = message;
//       errorContainer.style.display = 'block';
//       setTimeout(() => {
//         errorContainer.style.display = 'none';
//       }, 5000);
//     } else {
//       console.warn('Error container not found, using alert');
//       alert(message);
//     }
//   }
// });